export default __webpack_public_path__ + "static/media/Icedick.92ac55a7.png";